import { useDispatch, useSelector } from 'react-redux'
import axios from "axios";
import { useCookies } from 'react-cookie'
import { useEffect, useState } from "react"
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { getBizID, getStyle } from "../../libs/todoSlice";
import Box from '@mui/material/Box';
import React from "react";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { getAddEmailColorRedux, getAddEmailRedux, getDepartmentRedux, getEmailRedux, getLoaDataRedux, getMainPhoneNumberRedux, getOneMailRedux, getPhoneNumberRedux, getPositionRedux, getProfileRedux, getStepRedux, setAddEmailColorRedux, setAddEmailRedux, setDepartmentRedux, setEmailRedux, setLoaDataRedux, setMainPhoneNumberRedux, setOneMailRedux, setPhoneNumberRedux, setPositionRedux, setProfileRedux, setStepRedux } from "../../libs/profileSlice";
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { makeStyles } from "@material-ui/core";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloseIcon from '@mui/icons-material/Close';



const Profile = () => {
  // const dotenv = require('dotenv');
  // dotenv.config();

  const dispatch = useDispatch()
  const [cookie] = useCookies(['account'])
  const [account, setAccount] = useState({})
  const style = useSelector(getStyle)
  const [completed, setCompleted] = useState({});
  const profile = useSelector(getProfileRedux)
  const step = useSelector(getStepRedux)
  const email = useSelector(getEmailRedux)
  const business_id = useSelector(getBizID)
  const position = useSelector(getPositionRedux)
  const phoneNumber = useSelector(getPhoneNumberRedux)
  const loadata = useSelector(getLoaDataRedux)
  const department = useSelector(getDepartmentRedux)
  const onemail = useSelector(getOneMailRedux)
  const addemail = useSelector(getAddEmailRedux)
  const addemailcolor = useSelector(getAddEmailColorRedux)
  const mainPhoneNumber = useSelector(getMainPhoneNumberRedux)
  const [openPhone, setOpenPhone] = useState(false)
  const [openEmail, setOpenEmail] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data, status } = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/user/${business_id}`,
        })
        setProfile(data.data)

        if (Array.isArray(data.data.email)) {
          setEmail(data.data.email)
          const findMail = (data.data.email.find(item => {
            return item.pivot.primary_flg === "Y"
          }))
          setOneMail(findMail)
          if (email === undefined) {
            setEmail([{ email: "-" }])
          }
        }

        else {
          setEmail([{ email: "-" }])
        }

        if (Array.isArray(data.data.mobile)) {
          const findPhoneNum = (data.data.mobile.find(item => {
            return item.pivot.primary_flg === "Y"
          }))
          setMainPhoneNumber(findPhoneNum)
          setPhoneNumber(data.data.mobile)
          if (phoneNumber === undefined) {
            setPhoneNumber([{ mobile_no: '-' }])
          }
        }
        else {
          setPhoneNumber([{ mobile_no: '-' }])
        }
        setPosition(data.data.role_name)
        setDepartment(data.data.dept_name)

      } catch ({ response }) {
      }
      try {
        await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/loa-laval`,
        })
          .then(({ data, status }) => {
            setLoaData(data.data)
          }, ({ response, status }) => {
          })
      }
      catch {

      }
    };

    fetchData();
    setAddEmail(false)
    setAddEmailColor(false)
  }, [])

  const confirmEmail = async () => {
    await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/confirm/email`,
    })
      .then(({ data, status }) => {
        setStep("confirmemail")
      }, ({ response, status }) => {
      })
  }

  const confirmPhoneNumber = async () => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/confirm/mobile`,
    })
      .then(({ data, status }) => {
        setStep("confirmphonenumber")
      }, ({ response, status }) => {
      })
  }

  const setProfile = (action) => {
    dispatch(setProfileRedux({
      profile: action,
    }))
  }

  const setMainPhoneNumber = (action) => {
    dispatch(setMainPhoneNumberRedux({
      mainPhoneNumber: action,
    }))
  }

  const setAddEmail = (action) => {
    dispatch(setAddEmailRedux({
      addemail: action,
    }))
  }

  const setAddEmailColor = (action) => {
    dispatch(setAddEmailColorRedux({
      addemailcolor: action,
    }))
  }

  const setOneMail = (action) => {
    dispatch(setOneMailRedux({
      onemail: action,
    }))
  }

  const setLoaData = (action) => {
    dispatch(setLoaDataRedux({
      loadata: action,
    }))
  }

  const setPhoneNumber = (action) => {
    dispatch(setPhoneNumberRedux({
      phoneNumber: action,
    }))
  }

  const setEmail = (action) => {
    dispatch(setEmailRedux({
      email: action,
    }))
  }

  const setPosition = (action) => {
    dispatch(setPositionRedux({
      position: action,
    }))
  }

  const setDepartment = (action) => {
    dispatch(setDepartmentRedux({
      department: action,
    }))
  }


  const setStep = (action) => {
    dispatch(setStepRedux({
      step: action,
    }))
  }


  const DefaultTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      width: '279px',
      height: '38',
      backgroundColor: "#D7F4F2",
      color: '#333333',
      borderRadius: '16px',
      fontSize: 12,
    },
  }));

  const Modalstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'fit-content',
    backgroundColor: 'background.paper',
    border: 'none',
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
  };

  const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#CAF3DD',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#CAF3DD',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderTopWidth: 3,
      borderRadius: 1,
    },
  }));



  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    // Pad single-digit day and month with leading zero
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedDay}-${formattedMonth}-${year}`;
  };



  const useStyles = makeStyles(() => ({
    root: {
      "& .MuiStepIcon-root.Mui-completed": { color: "#119143" },
      "& .MuiStepIcon-root.Mui-active": { color: "#E0E0E0" },
      "& .Mui-disabled .MuiStepIcon-root": { color: "#E0E0E0" }
    }
  }));

  const handleClosePhoneModal = () => {
    setOpenPhone(false)
  }

  const handleCloseEmailModal = () => {
    setOpenEmail(false)
  }

  const stepicon = useStyles();

  const stepButton = { backgroundColor: 'white', border: 'none', color: 'red', textDecoration: 'underline' }

  return localStorage.getItem('account') && (
    <>
      <Modal
        open={openPhone}
        onClose={handleClosePhoneModal}
      >
        <Box sx={Modalstyle}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', position: 'absolute', top: '4%', left: '80%' }}>
            <CloseIcon style={{ cursor: 'pointer' }} onClick={handleClosePhoneModal} />
          </div>
          {phoneNumber.map((item) => (<>
            {item.mobile_no}<br />
          </>))}
        </Box>
      </Modal>
      <Modal
        open={openEmail}
        onClose={handleCloseEmailModal}
      >
        <Box sx={Modalstyle}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', position: 'absolute', top: '4%', left: '80%' }}>
            <CloseIcon style={{ cursor: 'pointer' }} onClick={handleCloseEmailModal} />
          </div>
          {email.map((item) => (<>
            {item.email}<br />
          </>))}
        </Box>
      </Modal>
      <div style={{ fontFamily: 'Sarabun', fontWeight: '600', fontSize: '32px', marginBottom: '32px', color: 'black' }}>
        สวัสดีคุณ ! คุณ {profile.first_name_th}
      </div>
      <div>
        <div style={{ fontFamily: 'Sarabun', fontWeight: '600', fontSize: '24px', marginBottom: '15px' }}>ข้อมูลระดับความน่าเชื่อถือบัญชีของคุณ <DefaultTooltip title="ระดับความน่าเชื่อถือของบัญชีจะแสดงก็ต่อเมื่อกรอกข้อมูลครบ" style={{ width: '20px', height: '20px', color: '#DADADA', marginLeft: '5px' }}><ErrorOutlineIcon /></DefaultTooltip></div>
        <div style={{ fontFamily: 'Sarabun', fontWeight: '600', fontSize: '18px', marginBottom: '10px', display: 'flex' }}> ความน่าเชื่อถือ (IAL) : <div>{loadata.ial_level}</div></div>
        <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '24px', color: '#757575', display: 'flex' }}>เมื่อวันที่: <div>{profile.status_dt ? formatDate(profile.status_dt) : '-'}</div></div>
      </div>
      <div style={{ marginBottom: '32px' }}>
        <div style={{ fontFamily: 'Sarabun', fontWeight: '600', fontSize: '18px', marginBottom: '10px', color: '#333333', display: 'flex' }}>ความน่าเชื่อถือ (LOA) :
          {(() => {
            if (loadata.loa_level === 0) {
              return (<div style={{ color: '#FF0000' }}>Level 0</div>)
            }
            else if (loadata.loa_level === 1) {
              return (<div style={{ color: '#E9A016' }}>Level 1</div>)
            }
            else if (loadata.loa_level === 2) {
              return (<div style={{ color: '#E9A016' }}>Level 2</div>)
            }
            else if (loadata.loa_level === 3) {
              return (<div style={{ color: '#119143' }}>Level 3</div>)
            }
            else if (loadata.loa_level === 4) {
              return (<div style={{ color: '#119143' }}>Level 4</div>)
            }
          })()}</div>
      </div>
      <Box style={{ marginBottom: '32px' }}>
        <div className="row">
          <div className="col">
            {loadata.email_confirm === true ? <div style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              padding: '8px'
            }}>
              <MailOutlineIcon style={{ width: '46.67px', height: '37.33px', color: '#119143' }} />
              <div><CheckCircleIcon style={{ color: '#119143' }} /></div>
              ยืนยันอีเมล
            </div> :
              <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                padding: '8px'
              }}>
                <MailOutlineIcon style={{ width: '46.67px', height: '37.33px', color: '#E0E0E0' }} />
                <div><CheckCircleIcon style={{ color: '#E0E0E0' }} /></div>
                ยืนยันอีเมล
                <button style={stepButton} onClick={() => { confirmEmail() }}>คลิกเพื่อยืนยันอีเมล</button>
              </div>
            }
          </div>
          <div className="col">
            {loadata.mobile_confirm === true ? <div style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              padding: '8px'
            }}>
              <PhoneIphoneIcon style={{ width: '46.67px', height: '37.33px', color: '#119143' }} />
              <div><CheckCircleIcon style={{ color: '#119143' }} /></div>
              ยืนยันเบอร์มือถือ
            </div> :
              <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                padding: '8px'
              }}>
                <PhoneIphoneIcon style={{ width: '46.67px', height: '37.33px', color: '#E0E0E0' }} />
                <div><CheckCircleIcon style={{ color: '#E0E0E0' }} /></div>
                ยืนยันเบอร์มือถือ
                <button style={stepButton} onClick={() => { confirmPhoneNumber() }}>คลิกเพื่อยืนยันเบอร์มือถือ</button>
              </div>
            }
          </div>
          <div className="col">
            {loadata.ekyc_confirm === true ? <div style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column'
            }}>
              <img alt="profile " src="/icon/profile3.png" style={{ width: '65px', height: '45.5px' }} />
              <div><CheckCircleIcon style={{ color: '#119143' }} /></div>
              ยืนยันตัวตน ผ่านระบบ Ekyc By ID Card
            </div> :
              <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                textAlign: 'center  '
              }}>
                <img alt="profile " src="/icon/profile3.png" style={{ width: '65px', height: '45.5px', filter: "grayscale(1)", opacity: '30%' }} />
                <div><CheckCircleIcon style={{ color: '#E0E0E0' }} /></div>
                ยืนยันตัวตน ผ่านระบบ Ekyc By ID Card
                <button style={stepButton} onClick={() => { window.location.href = `${process.env.REACT_APP_EKYC_URL}` }} >กรุณายืนยันตัวตนที่ www.ekyc.id.th</button>
              </div>}
          </div>
          <div className="col">
            {loadata.ca_confirm === true ? <div style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              textAlign: 'center  '
            }}>
              <img alt="profile " src="/icon/CA.png" style={{ width: '65px', height: '45.5px' }} />
              <div><CheckCircleIcon style={{ color: '#119143' }} /></div>
              ใบรับรองอิเล็กทรอนิกส์
            </div> :
              <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                textAlign: 'center  '
              }}>
                <img alt="profile " src="/icon/CA.png" style={{ width: '65px', height: '45.5px', filter: "grayscale(1)", opacity: '30%' }} />
                <div><CheckCircleIcon style={{ color: '#E0E0E0' }} /></div>
                ใบรับรองอิเล็กทรอนิกส์
                <button style={stepButton} onClick={() => { window.location.href = process.env.REACT_APP_CA_URL }}>กรุณาอัปเดตเอกสารที่ www.ca.inet.co.th</button>
              </div>
            }
          </div>
        </div>

      </Box>
      <div style={{ fontFamily: 'Sarabun', fontWeight: '600', fontSize: '20px', /* margin: '32px' */ marginBottom: '20px', color: 'black' }}>
        ข้อมูลพนักงาน
      </div >
      <div className="row" style={{ marginBottom: '32px' }}>
        <div className="col" >
          <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', color: "#7E7E7E" }}>
            ชื่อ - นามสกุล (ไทย) :
          </div>
          <div style={{ marginBottom: '15px' }}>
          {profile.special_title_name_th || profile.account_title_th || ''} {profile.first_name_th} {profile.last_name_th}
          </div>
          <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', color: "#7E7E7E" }}>
            หมายเลขบัตรประชาชน :
          </div>
          <div style={{ marginBottom: '15px' }}>
            {profile.id_card_num}
          </div>
          <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', color: "#7E7E7E" }}>
            แผนก :
          </div>
          <div style={{ marginBottom: '15px' }}>
            {department.map((item) => (<>
              {item}<br />
            </>))}
          </div>
          <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', color: "#7E7E7E" }}>
            อีเมล :
          </div>
          <div style={{ marginBottom: '15px' }}>
            {email[0]?.email ?? '-'}
            <div style={{ color: '#119143', cursor: 'pointer' }}
              onClick={() => { setOpenEmail(true) }}>
              <AddCircleOutlineIcon style={{ margin: 4 }} />ดูเพิ่มเติม
            </div>
          </div>
        </div>
        <div className="col">
          <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', color: "#7E7E7E" }}>
            ชื่อ - นามสกุล (อังกฤษ) :
          </div>
          <div style={{ marginBottom: '15px' }}>
          {profile.special_title_name_eng || profile.account_title_eng || ''} {profile.first_name_eng} {profile.last_name_eng}
          </div>
          <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', color: "#7E7E7E" }}>
            รหัสพนักงาน :
          </div>
          <div style={{ marginBottom: '15px' }}>
            {profile.employee_id}
          </div>
          <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', color: "#7E7E7E" }}>
            เบอร์มือถือ :
          </div>
          <div style={{ marginBottom: '15px' }}>
            <div>
              {phoneNumber[0]?.mobile_no ?? '-'}
              <div style={{ color: '#119143', cursor: 'pointer' }}
                onClick={() => { setOpenPhone(true) }}>
                <AddCircleOutlineIcon style={{ margin: 4 }} />ดูเพิ่มเติม
              </div>
            </div>
          </div>
        </div>
        <div className="col" >
          <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', color: "#7E7E7E" }}>
            วัน / เดือน / ปีเกิด :
          </div>
          <div style={{ marginBottom: '15px' }}>
            {(() => {
              const originalDate = profile.birth_date
              const formattedDate = new Date(originalDate).toLocaleDateString('en-GB')
              const parts = formattedDate.split('/');
              const finalDate = (parts[0]||parts[1]||parts[2]) ? `${parts[0]}-${parts[1]}-${parts[2]}`: '-';
              return <>{finalDate}</>
            })()}
          </div>
          <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', color: "#7E7E7E" }}>
            ตำแหน่ง :
          </div>
          <div style={{ marginBottom: '15px' }}>
            {position.map((item) => (<>
              {item}<br />
            </>))}
          </div>
          <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', color: "#7E7E7E" }}>
            อีเมลหลัก :
          </div>
          <div style={{ marginBottom: '15px' }}>
            {onemail ? onemail.email : "-"}
          </div>
        </div>
      </div>
      <div hidden={loadata.ial_level >= 1.3} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button style={{ border: 'none', backgroundColor: 'white' }} onClick={() => { setStep("editprofile") }}>
          <div style={{ fontFamily: 'Sarabun', fontWeight: '700', fontSize: '16px', marginBottom: '20px', color: 'black' }}>
            <SettingsOutlinedIcon style={{ marginRight: '5px' }} />
            ตั้งค่าข้อมูลพนักงาน
          </div>
        </button>
      </div>
    </>
  )
}

export default Profile